import { useWarrantyVoucherData } from "app/hooks/checkout/useWarrantyVoucherData";
import { useCartContext } from "app/providers/CartProvider";
import CheckoutWarrantyList from "features/checkout/warranty-list";
import Card from "shared/ui/card";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";

const CheckoutWarranty = () => {
  const { getFormattedWarrantyPackagePrice, voucherWarranties, getCart } =
    useCartContext();
  const cartValue = getCart();
  const { voucherWarrantyPackage } = useWarrantyVoucherData({
    cartValue,
    voucherWarranties,
  });

  const formattedWarrantyOriginalPrice = getFormattedPrice(
    voucherWarrantyPackage?.price || 0,
  );
  return (
    <Card className="gg-bg-grey-300 gg-px-4 sm:gg-px-14 md:gg-px-32 lg:gg-px-14 xl:gg-px-32">
      <section className="gg-pb-14 gg-pt-9">
        <Heading headingLevel="h2" className="gg-mb-6">
          GewoonZeker
        </Heading>
        <div className="gg-grid gg-grid-cols-12 gg-gap-y-6">
          <Text
            data-testid="gewoonzeker-header"
            className="gg-col-span-12 gg-text-lg lg:gg-col-span-8"
          >
            Dan biedt GewoonGers de mogelijkheid om je bestelling uit te breiden
            met een zekerheidspakket. Hiermee ontvang je 3 óf 5 jaar extra
            zekerheid op onder andere glas en poedercoat. Lees{" "}
            <a
              href="/zekerheidspakket-gewoonzeker/"
              target="_blank"
              rel="noreferrer"
              className="gg-font-bold hover:gg-text-gray-500"
            >
              hier
            </a>{" "}
            alle voorwaarden en kleine lettertjes.
          </Text>

          <div className="gg-order-2 gg-col-span-12 gg-col-start-8 gg-hidden md:gg-col-start-9 lg:gg-order-1 lg:gg-col-span-1 lg:gg-col-start-12 lg:gg-block">
            {voucherWarrantyPackage && (
              <p className="gg-self-center gg-text-xs gg-font-bold gg-text-gray-400 gg-line-through sm:gg-text-sm">
                {formattedWarrantyOriginalPrice}
              </p>
            )}
            <Text className="gg-mb-1 gg-text-xl" bold>
              {getFormattedWarrantyPackagePrice()}
            </Text>

            <Text className="gg-text-xs gg-text-dark-blue-800">
              Eénmalige kosten, <br className="gg-hidden xl:gg-block"></br>
              inclusief BTW
            </Text>
          </div>

          <CheckoutWarrantyList className="gg-order-1 gg-col-span-12 lg:gg-order-2" />
        </div>
      </section>
    </Card>
  );
};
export default CheckoutWarranty;
